import $ from 'lib/jquery.ui';
import FastActionUser from 'app/models/FastActionUser';
import { FastActionPopupWindowRoute } from '@NGPVAN/fastaction-client';

var tknfa = /&tknfa=[^&]+/;

export default function () {

  $('a[data-popup]').off('click').on('click', function (e) {
    var l = window.location;

    if ($(this).data('fastactionAction') === 'logout') {
      e.preventDefault();
      return FastActionUser.logout()
        .then(function () {
          FastActionUser.clear();
          if (tknfa.test(l.search)) {
            window.location = l.protocol + '//' + l.host + l.pathname + l.search.replace(tknfa, '');
          } else {
            FastActionUser.fetch();
          }
        });
    }

    var routeName = $(this).data('fastactionRoute');
    if (routeName) {
      var route = FastActionPopupWindowRoute[routeName];
      if (route) {
        e.preventDefault();
        var result = FastActionUser.openFastActionPopupWindow({
          route: route,
          onOpen: function () {},
          onClose: function () {
            if (window.location.hash) {
              window.location.hash = '!';
            }
            FastActionUser.fetch();
          }
        });
        if (!result.window) {
          console.error('Failed to open FastAction popup window');
        }
      }
      return;
    }

    // Fallback: Handle generic data-popup links (e.g., "what's this" help links)
    var $link = $(this);
    var width = $link.data('popupWidth');
    var height = $link.data('popupHeight');
    var top = $link.data('popupTop');
    var left = $link.data('popupLeft');

    if (width || height) {
      e.preventDefault();
      var url = $link.attr('href');
      var windowFeatures = [
        width && 'width=' + width,
        height && 'height=' + height,
        top !== undefined && 'top=' + top,
        left !== undefined && 'left=' + left
      ].filter(function(feature) { return feature; }).join(',');
      
      window.open(url, '_blank', windowFeatures);
    }
  });
}
